var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.drawer,
            size: "600px",
            wrapperClosable: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "form-center",
            },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.form,
                    "label-width": "120px",
                    rules: _vm.rules,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "资产分类编号",
                        prop: "AssetCategoryCode",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入资产分类编号" },
                        model: {
                          value: _vm.form.AssetCategoryCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "AssetCategoryCode", $$v)
                          },
                          expression: "form.AssetCategoryCode",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "资产分类名称", prop: "AssetCategory" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入资产分类名称" },
                        model: {
                          value: _vm.form.AssetCategory,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "AssetCategory", $$v)
                          },
                          expression: "form.AssetCategory",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注", prop: "Remark" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "",
                          type: "textarea",
                          rows: "3",
                          resize: "none",
                        },
                        model: {
                          value: _vm.form.Remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "Remark", $$v)
                          },
                          expression: "form.Remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }